<template>
    <div>
        <div id="updateModal" class="modal">
            <div class="modal-contents">
                <span class="close" @click="modalClose()">&times;</span>
                <!--about me-->
                <div v-if="type == 'about'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="edit-work-exp">
                                <h1 class="main-heading"> edit about me</h1>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <form action="" @submit.prevent="saveAbout">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="aboutMe" class="ep-input-label">About Me</label>
                                    <textarea id="aboutMe" class="form-control dash-input" v-model="about"></textarea>
                                </div>
                                <div id="about-er" v-html="about_error" class="form-text text-muted"></div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group text-center">
                                    <button type="submit" class="update-profile">Update</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!--work experience-->
                <div class="workExperience" v-if="type == 'work'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="edit-work-exp">
                                <div class="col-md-12 text-center">
                                    <h1 class="main-heading">Edit work experience</h1>
                                </div>
                                <form action="" @submit.prevent="saveWork">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="ep-input-label" for="title">Title</label>
                                            <input type="text" v-model="title" class="form-control dash-input"
                                                   id="title">
                                            <div id="title-er" v-html="title_error" class="form-text text-muted"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="ep-input-label" for="company">Company</label>
                                            <input type="text" v-model="company" class="form-control dash-input"
                                                   id="company">
                                            <div id="company-er" v-html="company_error"
                                                 class="form-text text-muted"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <p>From Date</p>
                                            <date-picker v-model="work_from_date" format="YYYY-MM-DD" lang="en"
                                                         appendToBody
                                                         :not-after="today" input-class="form-control dash-input"></date-picker>
                                            <div id="duration-er" v-html="work_start_error"
                                                 class="form-text text-muted"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <p>To Date</p>
                                            <date-picker v-model="work_to_date" format="YYYY-MM-DD" lang="en"
                                                         appendToBody
                                                         :not-after="today" :not-before="work_from_date" input-class="form-control dash-input"></date-picker>
                                            <div id="duration-er" v-html="work_end_error"
                                                 class="form-text text-muted"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label class="ep-input-label" for="job-des">Job Description</label>
                                            <textarea id="job-des" v-model="jobDescription"
                                                      class="form-control dash-input"></textarea>
                                            <div id="job-er" v-html="job_error" class="form-text text-muted"></div>
                                        </div>
                                    </div>
                                    <div class="form-group text-center">
                                        <button type="submit" class="update-profile">Update</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <!--education-->
                <div v-if="type == 'education'">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h1 class="main-heading">Edit Educational Background</h1>
                        </div>
                    </div>
                    <div class="row">
                        <form action="" @submit.prevent="saveEducation">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="degree" class="ep-input-label">Course</label>
                                        <input type="text" id="degree" class="form-control dash-input" v-model="degree">
                                        <div id="degree-eb" v-html="degree_error" class="form-text text-muted"></div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="ep-input-label">From Date</label>
                                        <date-picker class="form-control" v-model="starting_year" format="YYYY-MM-DD" input-class="form-control dash-input"
                                                     lang="en"
                                                     appendToBody></date-picker>
                                        <div id="duration-eb" v-html="edu_from_error"
                                             class="form-text text-muted"></div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="ep-input-label">To Date</label>
                                        <date-picker class="form-control" v-model="ending_year" format="YYYY-MM-DD"
                                                     lang="en" appendToBody
                                                     :not-before="starting_year" input-class="form-control dash-input"></date-picker>
                                        <div id="duration-to" v-html="edu_to_error" class="form-text text-muted"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="institution" class="ep-input-label">University or College</label>
                                        <input type="text" id="institution" class="form-control dash-input"
                                               v-model="college">
                                        <div id="institution-eb" v-html="college_error"
                                             class="form-text text-muted"></div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="cgpa" class="ep-input-label">CGPA</label>
                                        <input type="number" id="cgpa" class="form-control dash-input" v-model="cgpa"
                                               placeholder="1.00" step="0.01" min="0" max="10">
                                        <div id="cgpa-eb" v-html="cgpa_error" class="form-text text-muted"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group text-center">
                                        <button type="submit" class="update-profile">Update</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!--skills-->
                <div v-if="type == 'skills'">
                    <div class="row">
                        <div class="col-md-12">
                            <h1 class="main-heading">edit skills</h1>
                        </div>
                    </div>
                    <div class="row">
                        <form action="" @submit.prevent="saveSkills">
                            <div class="col-md-12 col-sm-12">
                                <div class="form-group">
                                    <label class="ep-input-lable" for="skills">Skills</label>
                                    <tags-input element-id="skilltags"
                                                v-model="skillSelectedTags"
                                                :existing-tags="skill_existing_tags"
                                                :typeahead="true"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"></tags-input>
                                </div>
                                <div id="skill-er" v-html="skill_error" class="form-text text-muted"></div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group text-center">
                                    <button type="submit" class="update-profile">Update</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

export default {
    components: {DatePicker},
    data() {
        return {
            work_from_date: '',
            cgpa: '',
            cgpa_error: '',
            work_to_date: '',
            today: new Date(),
            id: '',
            title: '',
            duration: '',
            company: '',
            jobDescription: '',
            title_error: '',
            work_start_error: '',
            work_end_error: '',
            company_error: '',
            job_error: '',
            about_error: '',
            skill_error: '',
            form_data: '',
            type: '',
            about: '',
            //education variables
            degree: '',
            college: '',
            starting_year: '',
            ending_year: '',
            degree_error: '',
            college_error: '',
            edu_from_error: '',
            edu_to_error: '',
            skill_existing_tags: [],
            skillSelectedTags: [],
            // custom range shortcuts
            // shortcuts: [
            //     {
            //         text: 'Today',
            //         onClick: () => {
            //             this.time1 = [ new Date(), new Date() ]
            //         }
            //     }
            // ],
        }
    },
    mounted() {
        if (!document.getElementById('my-datepicker')) {
            var scriptTag = document.createElement("script");
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/css/datepicker.css';
            scriptTag.src = "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/js/bootstrap-datepicker.js";
            scriptTag.id = "my-datepicker";
            document.getElementsByTagName('head')[0].appendChild(link);
            document.getElementsByTagName('head')[0].appendChild(scriptTag);
        }
        var t = this;
        var url = t.$store.getters.getDomain;

        //request to get skills
        // axios.post(`${url}api/v2/cand-profile/get-skills`, '', {}).then(function (response) {
        //     t.skill_existing_tags = response['data']['response'];
        // });
    },
    methods: {
        setEduFields: function (val, type) {
            var t = this;
            t.degree_error = '';
            t.college_error = '';
            t.edu_from_error = '';
            t.edu_to_error = '';
            t.id = val[0]['education_enc_id'];
            t.type = type;
            t.degree = val[0]['degree'];
            t.college = val[0]['institute'];
            t.cgpa = val[0]['cgpa'];
            t.starting_year = val[0]['from_date'];
            t.ending_year = val[0]['to_date'];

        },
        setWorkFields: function (val, type) {
            var t = this;
            t.title_error = "";
            t.start_duration_error = "";
            t.end_duration_error = "";
            t.company_error = "";
            t.job_error = "";
            $(".date").datepicker({
                autoclose: true,
                todayHighlight: true
            });
            t.type = type;
            t.id = val[0]['id'];
            this.title = val[0]['title'];
            t.work_from_date = val[0]['from_date'];
            t.work_to_date = val[0]['to_date'];
            this.company = val[0]['company'];
            this.jobDescription = val[0]['description'];
        },
        enableForm: function (type) {
            var t = this;
            t.id = '';
            t.college = '';
            t.degree = '';
            t.title = '';
            t.company = '';
            t.jobDescription = '';
            $('#start_date').val('');
            $('#end_date').val('');
            $('#work_start_date').val('');
            $('#work_end_date').val('');
            t.about = t.$store.getters.getAbout;
            t.skillSelectedTags = t.$store.getters.getSkills;
            t.type = type;
        },
        modalClose() {
            $('#updateModal').css({"display": "none"});
        },
        sub: function (event) {
            this.title_error = "";
            this.duration_error = "";
            this.company_error = "";
            this.job_error = "";
            if (this.title == "") {
                this.title_error = "Title can't be blank"
            }
            if (this.duration == "") {
                this.duration_error = "Duration can't be blank"
            }
            if (this.company == "") {
                this.company_error = "Company can't be blank"
            }
            if (this.jobDescription == "") {
                this.job_error = "Job Description can't be blank"
            }
        },
        saveAbout: function () {
            var t = this;

            t.about_error = '';
            if (t.about == "") {
                t.about_error = "About can't be blank";
                return false;
            }

            var data = {'description': t.about};
            var url = t.$store.getters.getDomain;

            axios.post(`${url}api/v2/cand-resume/save-about`, data, {
                headers: requestHeaders()
            }).then(function (response) {
                $('#updateModal').css({"display": "none"});
                if (response['data']['response']['status'] == 200) {
                    t.$store.dispatch('setAbout', t.about);
                }
            }).catch(function (error) {
                console.log(error)
            });
        },
        saveEducation: function () {
            var t = this;
            var flag = 0;

            t.degree_error = '';
            t.college_error = '';
            t.edu_from_error = '';
            t.edu_to_error = '';
            t.cgpa_error = '';
            if (t.degree == '') {
                t.degree_error = "Degree can't be blank";
                flag = 1;
            }
            if (t.college == '') {
                t.college_error = "College can't be blank";
                flag = 1;
            }
            if (t.starting_year == '' || t.starting_year == null) {
                t.edu_from_error = "Date from can't be blank";
                flag = 1;
            }
            if (t.ending_year == '' || t.ending_year == null) {
                t.edu_to_error = "Date to can't be blank";
                flag = 1;
            }
            if (t.cgpa == '') {
                t.cgpa_error = "CGPA can't be blank";
            }

            if (flag == 1) {
                return false;
            }

            var d = new Date(t.starting_year);
            var from = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            var dd = new Date(t.ending_year);
            var to = dd.getFullYear() + '-' + (dd.getMonth() + 1) + '-' + dd.getDate();

            var data =
                {
                    'id': t.id,
                    'degree': t.degree,
                    'college': t.college,
                    'cgpa': t.cgpa,
                    'from': from,
                    'to': to,
                };
            var url = t.$store.getters.getDomain;
            showLoader();
            axios.post(`${url}api/v2/cand-resume/save-qualification`, data, {
                headers: requestHeaders()
            }).then(function (response) {
                hideLoader();
                $('#updateModal').css({"display": "none"});
                if (response['data']['response']['status'] == 200) {
                    var edu_data = response['data']['response']['data'];
                    t.$store.dispatch("saveEducation", edu_data);

                }
            }).catch(function (error) {
                console.log(error)
            });
        },
        saveWork: function () {
            var t = this;
            var flag = 0;

            t.title_error = "";
            t.work_start_error = "";
            t.work_end_error = "";
            t.company_error = "";
            t.job_error = "";
            if (this.title == "") {
                this.title_error = "Title can't be blank";
                flag = 1;
            }
            if (t.work_from_date == '' || t.work_from_date == null) {
                t.work_start_error = "From date can't be blank";
                flag = 1;
            }
            if (t.work_to_date == '' || t.work_to_date == null) {
                t.work_end_error = "To date can't be blank";
                flag = 1;
            }
            if (this.company == "") {
                this.company_error = "Company can't be blank";
                flag = 1;
            }
            if (this.jobDescription == "") {
                this.job_error = "Job Description can't be blank";
                flag = 1;
            }

            if (flag == 1) {
                return false;
            }

            var d = new Date(t.work_from_date);
            var from = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            var dd = new Date(t.work_to_date);
            var to = dd.getFullYear() + '-' + (dd.getMonth() + 1) + '-' + dd.getDate();

            var data =
                {
                    'id': t.id,
                    'title': t.title,
                    'company': t.company,
                    'description': t.jobDescription,
                    'from': from,
                    'to': to,
                };
            var url = t.$store.getters.getDomain;
            showLoader();
            axios.post(`${url}api/v2/cand-resume/save-experience`, data, {
                headers: requestHeaders()
            }).then(function (response) {
                hideLoader();
                $('#updateModal').css({"display": "none"});
                if (response['data']['response']['status'] == 200) {
                    var work = response['data']['response']['data'];
                    t.$store.dispatch("saveExperience", work);
                }
            }).catch(function (error) {
                console.log(error)
            });
        },
        saveSkills: function () {
            var t = this;

            t.skill_error = '';

            if (t.skillSelectedTags.length == 0) {
                t.skill_error = "Skills can't be blank";
                return false;
            }

            var data = {'skills': t.skillSelectedTags};
            var url = t.$store.getters.getDomain;

            axios.post(`${url}api/v2/cand-resume/save-skills`, data, {
                headers: requestHeaders()
            }).then(function (response) {
                $('#updateModal').css({"display": "none"});
                if (response['data']['response']['status'] == 200) {
                    var skills = response['data']['response']['skills'];
                    t.skillSelectedTags = [];
                    //loop to get skills
                    for (var i = 0; i < skills.length; i++) {
                        var demo = {};
                        demo['key'] = skills[i]['skill_enc_id'];
                        demo['value'] = skills[i]['skill'];
                        t.skillSelectedTags.push(demo)
                    }
                    t.$store.dispatch('setSkills', t.skillSelectedTags);
                }
            }).catch(function (error) {
                console.log(error)
            });
        },
    }
}
</script>
<style scoped>
.modal-contents {
    overflow: hidden !important;
    position: relative;
    background-color: #fff;
    overflow-y: scroll !important;
    margin: 20vh auto;
    padding: 10px 40px !important;
    width: 60vw;
    height: 60vh;
}
</style>